import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
    Button, CircularProgress, Container, Snackbar, Stack, TextField,
} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { IMAGE_ASSETS } from "../../Assets/img/getImg";
import { auth } from "../../Client/Auth/login.client";
import { useUIStatus } from "../../Hooks/UI/useModeStatus";
import { useAppDispatch } from "../../Redux/Hooks/hooks.redux";
import { setAuthState } from "../../Redux/Reducer/app.state.reducer";
import { setNetworkState } from '../../Redux/Reducer/network.state.reducer';
import { AuthState } from "../../State/Auth/auth.state";
import { Alert } from "../Misc/Alert";
import { Navigate } from "react-router-dom";
export const LoginForm: React.FC = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const dispatch = useAppDispatch();
    const [error, setError] = useState(false)
    const [processing, setProcessing] = useState(false)

    const [eyeOpen, setEyeOpen] = useState(false);
    const [redirectTo, setRedirectTo] = useState("")

    const mode = useUIStatus()
    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        setProcessing(true)
        setError(false)
        auth(email, password).then((response: AuthState) => {
            dispatch(setAuthState(response))
        }).catch((e: AxiosError) => {
            setError(true)

            if (e.response && e.response.status && e.response.status !== 401) {
                dispatch(setNetworkState(true))
            }
        }).finally(() => setProcessing(false))
    };

    const forgotPassword = () => {
        setRedirectTo("/auth/startReset")
    }

    if(redirectTo) {
        return <Navigate to={redirectTo}></Navigate>
    }

    return (
        <div data-testid="login-container" role="main">
            <Container maxWidth="sm" style={{ marginTop: '64px', textAlign: "center", width: '100vw', alignItems: "center" }} >
                <h1><img style={{ width: '300px' }} src={mode === "light" ? IMAGE_ASSETS["roper_full"] : IMAGE_ASSETS["roper_full_light"]} alt="Roper Center for Public Opinion Research -- Data Deposit Login"></img></h1>
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                    <Alert onClose={() => setError(false)} severity="error" sx={{ width: '100%' }}>
                        Invalid credentials.
                    </Alert>
                </Snackbar>
                <form style={{ marginTop: "20px" }} onSubmit={handleSubmit}>
                    <Stack spacing={2}>
                        <TextField
                            label="Email"
                            type="email"
                            variant="outlined"
                            inputProps={{ 'data-testid': 'email-field' }}

                            fullWidth
                            required
                            value={email}
                            onChange={handleEmailChange}
                        />
                        <TextField
                            inputProps={{ 'data-testid': 'password-field' }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setEyeOpen(!eyeOpen)}
                                            edge="end"
                                        >
                                            {!eyeOpen ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            label="Password"
                            type={eyeOpen ? 'text' : 'password'}
                            variant="outlined"
                            fullWidth
                            required
                            value={password}
                            onChange={handlePasswordChange}
                        />
                        <Button
                            aria-label="login"
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={processing}
                            data-testid="submit-btn"
                        >
                            Login
                        </Button>
                    </Stack>
                    {processing && <CircularProgress sx={{ textAlign: 'center', mt: 2 }}></CircularProgress>}
                </form>
                <Button
                  aria-label="forgot password"
                  type="submit"
                  variant="contained"
                  color="secondary"
                  fullWidth
                  disabled={processing}
                  data-testid="forgot-btn"
                  onClick = {forgotPassword}
                  sx={{mt: 1}}
                >
                    Forgot Password
                </Button>
            </Container>
        </div>
    );
}
